import { Component, Prop, h, Host } from '@stencil/core';

export type UuiTabsOrientationType = 'vertical' | 'horizontal';

/**
 * @slot default - Slot for the content of the paragraph
 */
@Component({
  tag: 'uui-tabs',
  styleUrl: 'uui-tabs.css',
  shadow: true
})
export class UUITabs {
  /** orientation of tabs */
  @Prop({ reflect: true }) orientation?: UuiTabsOrientationType = 'horizontal';
  @Prop({ mutable: true, reflect: true }) fillevenly?: boolean;
  @Prop({reflect: true}) type: 'icon' | 'text' = 'text';

  render() {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
